import { Amplify } from 'aws-amplify';
import { getUpdatedAwsConfig } from 'updatedConfig';
import { initializeAmplifyAuth } from './initializeAmplifyAuth';

export const configureAndInitializeAmplify = (
  isSaml = false,
  isSAMLInRoute = false,
) => {
  Amplify.configure(getUpdatedAwsConfig(isSaml, isSAMLInRoute));
  initializeAmplifyAuth();
};
